import { render, staticRenderFns } from "./ApprovalOverdueCriteriaCard.vue?vue&type=template&id=27f73c4d&"
import script from "./ApprovalOverdueCriteriaCard.vue?vue&type=script&lang=js&"
export * from "./ApprovalOverdueCriteriaCard.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalOverdueCriteriaCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports